import { Component, Input, OnInit } from '@angular/core';
import { RepoSettingsService } from '../../../data/repositories/repo-settings.service';
import { RouterStateService } from '../../../core/routing/router-state.service';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'app-sidebar2-checkbox-dropdown',
    templateUrl: './sidebar2-checkbox-dropdown.component.html',
    standalone: false,
})
export class Sidebar2CheckboxDropdownComponent implements OnInit {
    // @ts-ignore TS2564
    @Input() heading: string;
    headingId?: string;
    @Input() showChevron = true;
    @Input() options: any;
    // @ts-ignore TS2564
    @Input() settingsFlag: string;
    // @ts-ignore TS2564
    @Input() defaultRoute: string;
    @Input() defaultQueryParams: any;
    // @ts-ignore TS2564
    @Input() paramName: string;

    $state: any;
    $stateParams: any;
    opened = true;
    DELIMITER = '|';
    // @ts-ignore TS7008
    selections;

    constructor(
        private routerStateService: RouterStateService,
        private router: Router,
        private repoSettings: RepoSettingsService
    ) {}

    ngOnInit() {
        this.routerStateService.routeChanged$.pipe(untilDestroyed(this)).subscribe(() => {
            // Only process route changes if it relates to the route for this instance
            if (this.routerStateService.getCurrentUrlRoute() !== this.defaultRoute) return;
            this.getSelections(null, false);
            // @ts-ignore TS7052
            const savedRoute = this.repoSettings[this.settingsFlag + 'RoutePath'];
            if (this.routerStateService.getCurrentUrlRoute() === savedRoute) {
                this.opened = true;
            }
        });

        this.headingId = `sidebar2-checkbox-dropdown-header-${this.heading.toLowerCase()}`;
        while (this.headingId.includes(' ')) this.headingId = this.headingId.replace(' ', '-');
    }

    // @ts-ignore TS7006
    getSelections(destRoute, defaultToAll?: bool = false) {
        const route = destRoute || this.routerStateService.getCurrentUrlRoute();
        const params = this.routerStateService.getCurrentUrlQueryParams();

        if (!destRoute && params[this.paramName]) {
            this.selections = params[this.paramName].split(this.DELIMITER);
        } else {
            const statusSelectionsKey = this.getStatusSelectionsSettingsFlag(route);
            if (statusSelectionsKey) {
                if (this.repoSettings[statusSelectionsKey]) {
                    this.selections = this.repoSettings[statusSelectionsKey].split(this.DELIMITER);
                } else if (defaultToAll) {
                    this.selections = this._useAllStatuses();
                }
            }
        }
    }

    // Toggle selection for a given fruit by name
    // @ts-ignore TS7006
    toggleSelection(item) {
        const convertedItem = this.convertKey(item);

        if (this.selections === undefined) this.selections = [];

        const idx = this.selections.indexOf(convertedItem);

        if (idx > -1) {
            // Is currently selected
            if (convertedItem === 'all') {
                this.selections = [];
            } else {
                this.selections.splice(idx, 1);
                // @ts-ignore TS7006
                const lowerCaseSelections = this.selections.map((s) => {
                    return s.toLowerCase();
                });
                const indexOfAll = lowerCaseSelections.indexOf('all');
                if (indexOfAll !== -1) this.selections.splice(indexOfAll, 1); // Remove all from start too
            }
        } else {
            // Is newly selected
            if (convertedItem === 'all') {
                this.selections = this._useAllStatuses();
            } else {
                this.selections.push(convertedItem); // Part of pushing all items in as selected for default list of cb/rd switches
            }
        }

        const remappedSelections = this.selections.length ? this.selections.join(this.DELIMITER) : '';
        let currentRouteUrl = this.routerStateService.getCurrentUrlRoute();

        let statusSelectionsKey = this.getStatusSelectionsSettingsFlag(currentRouteUrl) ?? `${this.settingsFlag}StatusSelections`;
        // @ts-ignore TS7052
        this.repoSettings[statusSelectionsKey] = remappedSelections;

        const newParams = this.routerStateService.getCurrentUrlQueryParams();
        const destParams = JSON.parse(JSON.stringify(newParams));
        destParams[this.paramName] = remappedSelections;

        this.router.navigate([currentRouteUrl], { queryParams: destParams, queryParamsHandling: 'replace', onSameUrlNavigation: 'reload' });
    }

    getHeaderLink() {
        // Just having a default route
        const destRoute = this.defaultRoute || this.routerStateService.getCurrentUrlRoute();
        const params = this.routerStateService.getCurrentUrlQueryParams();

        if (this.options) {
            const differentSubMenu = params?.submenu !== this.defaultQueryParams?.submenu;
            this.getSelections(destRoute, differentSubMenu); // This is only for non-radio dropdowns outputting list of checkboxes
        }

        const paramsToUse =
            this.defaultQueryParams && params.submenu !== this.defaultQueryParams.submenu ? this.defaultQueryParams : params;
        const destParams = JSON.parse(JSON.stringify(paramsToUse)) || {}; // Clone so we don't alter the state params here

        destParams.submenu = this.heading.toLowerCase().split(' ').join('-');
        destParams.subpanel = 'true';

        // Set the open destination parameter value
        destParams.open = destParams.open && destParams.open === 'true' ? 'false' : 'true';

        // Heading to a different route or submenu under this panel? Make it default to open...
        // But only make it default to open if we are not a dropdown with radio selections in it (cos they will be all different subRoutes)
        if (this.defaultRoute !== this.routerStateService.getCurrentUrlRoute() || params.submenu !== this.defaultQueryParams.submenu) {
            destParams.open = 'true';
        }

        if (this.selections) destParams[this.paramName] = this.selections.join(this.DELIMITER);

        // Don't stash any settings if we're on a non-replacement route (routeLess panel)
        if (!this.repoSettings.ShowIntegrationsPanel && !this.repoSettings.ShowExplorePanel && !this.repoSettings.ShowMyProfilePanel) {
            // @ts-ignore TS7052
            this.repoSettings[this.settingsFlag + 'RoutePath'] = destRoute;
            // @ts-ignore TS7052
            this.repoSettings[this.settingsFlag + 'Params'] = JSON.stringify(destParams);
        }

        this.router.navigate([destRoute], { queryParams: destParams, queryParamsHandling: 'replace', onSameUrlNavigation: 'reload' });
    }

    _useAllStatuses() {
        if (!this.options || this.options.length < 1) return;
        // Might have to loop over Object's values here rather than array of objects
        // This is because for order status and invoice status filters the counters are set up as objects with keys
        // where as for typical job status filter checkboxes we're looking at a list of objects
        // let statusObj = this.options.values || this.options
        const selections = [];

        for (const s in this.options) {
            if (this.convertKey(s) !== 'bin') selections.push(this.convertKey(this.options[s]));
        }

        return selections;
    }

    // @ts-ignore TS7006
    convertKey(item) {
        if (typeof item === 'string') return item.toLowerCase().split(' ').join('');

        const key = item.Value || item.Status || item.status;
        if (typeof key === 'string') return key.toLowerCase().split(' ').join('');
    }

    // @ts-ignore TS7006
    trackByFn(i) {
        return i;
    }

    private getStatusSelectionsSettingsFlag(route: string) {
        let settingKey = '';
        switch (route) {
            case '/estimates/list':
                settingKey = 'Estimates';
                break;
            case '/jobs/list':
                settingKey = 'Jobs';
                break;
            case '/jobs/orders':
                settingKey = 'JobsOrder';
                break;
            case '/jobs/invoices':
                settingKey = 'JobsInvoice';
                break;
            case '/quoterequests/list':
                settingKey = 'QuoteRequests';
                break;
            case '/customers/list':
                settingKey = 'Clients';
                break;
            case '/contacts/list':
                settingKey = 'Contacts';
                break;
            case '/customers/connections':
                settingKey = 'ClientConnections';
                break;
        }
        return settingKey !== '' ? `NavigationV2${settingKey}StatusSelections` : null;
    }
}
